import { cn } from "../../lib/cn";

import { Label } from "../label";

interface FormLabelGroupProps {
  label: string;
  htmlFor?: string;
  required?: boolean;
  children: React.ReactNode;
  className?: string;
}

function FormLabelGroup({
  label,
  htmlFor,
  required,
  children,
  className,
}: FormLabelGroupProps) {
  return (
    <div className={cn("grid w-full items-center gap-2", className)}>
      <Label htmlFor={htmlFor}>
        {label}
        {required ? <span className="ml-1 text-destructive">*</span> : null}
      </Label>
      {children}
    </div>
  );
}

export { FormLabelGroup };
